module.exports = "./assets/assets/需求调研模板.0212e8f0.docx";